// extracted by mini-css-extract-plugin
export default {"UnprotectedView":"UnprotectedView_UnprotectedView__TS+hf","switcher":"UnprotectedView_switcher__GQz+j"};